import { FC } from "react"
import classNames from "classnames"
import Spinner, { SpinnerProps } from "@/components/shared/Spinner"
import "./index.scss"

type LoaderProps = SpinnerProps & {
   fullHeight?: boolean
}

const Loader: FC<LoaderProps> = ({ size, fullHeight = true }) => {
   return (
      <div
         className={classNames("loader", { "loader--full-height": fullHeight })}
      >
         <Spinner size={size} />
      </div>
   )
}

export default Loader
